import { Redirect, Route as ReactRouter, Switch } from 'react-router-dom'
import { NotFoundPage } from '../pages/NotFound'
import Home from '../pages/Home'
import Dashboard from '../pages/Dashboard'
import SignIn from '../pages/Signin'
import { MenusRouter } from './menus/MenusRouter'
import { useAuth } from '../hooks/auth'
import { ForgotPassword } from '../pages/ForgotPassword'
import { UsersRouter } from './users/UsersRouter'
import { OperationIndexesRouter } from './financial/OperationIndexesRouter'
import { SimulationsRouter } from './simulation/SimulationsRouter'
import { ClientsRouter } from './commercial/ClientsRouter'
import PrivateRoutes from './PrivateRoute'

const Routes: React.FC = () => {
  const { userLogged, backupHistory } = useAuth()
  return (
    <Switch>
      <ReactRouter path="/" exact component={Home} />
      <PrivateRoutes path="/dashboard" exact component={Dashboard} />
      <ReactRouter path="/simulation" component={SimulationsRouter} />
      <ReactRouter path="/signin" exact component={SignIn}>
        {!backupHistory.length && userLogged() && <Redirect to="/dashboard" />}
      </ReactRouter>
      <ReactRouter path="/users" component={UsersRouter} />
      <ReactRouter path="/commercial/clients" component={ClientsRouter} />
      <ReactRouter
        path="/financial/operationIndexes"
        component={OperationIndexesRouter}
      />
      <ReactRouter path="/menus" component={MenusRouter} />
      <ReactRouter path="/forgot" component={ForgotPassword} />
      <ReactRouter path="*" component={NotFoundPage} />
    </Switch>
  )
}
export default Routes
